<mat-card
    class="buy-sell-plan-details"
    role="region"
    [attr.aria-label]="'BuySellRequestDetails' | translate: {Default: 'Buy/Sell Request Details'}">
    <mat-card-title>
        <h6 id="buy-sell-approval-summary-title" tabindex="0" appLocalizationPopupDirective localizationCode="BuySellRequestDetails">
            {{ 'BuySellRequestDetails' | translate: {Default: "Buy/Sell Request Details"} }}
        </h6>
    </mat-card-title>

    <mat-card-content>
        <dl class="detail-list" aria-labelledby="buy-sell-approval-summary-title">
            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellApprovalStatus">
                    {{ 'BuySellApprovalStatus' | translate: {Default: "Status"} }}
                </dt>
                <dd class="value">
                    <mat-chip-set
                        *ngIf="buySellPlanEmployee"
                        [attr.aria-label]="'BuySellApprovalStatus' | translate: {Default: 'Status'}">
                        <mat-chip
                            [ngClass]="getStatusChipClass()"
                            [attr.aria-label]="buySellPlanEmployee.status?.name"
                            role="status">
                            {{ buySellPlanEmployee.status?.name }}
                        </mat-chip>
                    </mat-chip-set>
                </dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellRequestType">
                    {{ 'BuySellRequestType' | translate: {Default: "Request Type"} }}
                </dt>
                <dd class="value">
                    {{ selectedType === 'BUY'
                        ? ('Buy' | translate: {Default: 'Buy'})
                        : ('Sell' | translate: {Default: 'Sell'}) }}
                </dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellRequestedHours">
                    {{ 'BuySellRequestedHours' | translate: {Default: "Requested Hours"} }}
                </dt>
                <dd class="value">{{ buySellPlanEmployee?.hours }}</dd>
            </div>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective localizationCode="BuySellHourlyRate">
                    {{ 'BuySellHourlyRate' | translate: {Default: "Hourly Rate"} }}
                </dt>
                <dd class="value">
                    {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost }}
                </dd>
            </div>

            <div class="detail-row">
                <dt
                    *ngIf="selectedType === 'BUY'"
                    class="label"
                    appLocalizationPopupDirective localizationCode="SalaryDeduction">
                    {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
                </dt>
                <dt
                    *ngIf="selectedType === 'SELL'"
                    class="label"
                    appLocalizationPopupDirective localizationCode="SalaryAddition">
                    {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
                </dt>
                <dd class="value">
                    {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hours * buySellPlanEmployee?.hourlyCost }}
                </dd>
            </div>
        </dl>
    </mat-card-content>
</mat-card>